import { graphql, useStaticQuery } from "gatsby"

// The profile page sections are read here rather than in the webpage query.
// See the note on these types in gatsby-node.js. Returns every entry of them,
// keyed by id, so the webpage template can look up the ones a page links.
export const useProfileSections = () => {
  const data = useStaticQuery(
    graphql`
      query GetProfileSections {
        socialFollows: allContentfulSectionSocialFollowV2 {
          nodes {
            id
            title
            text {
              text
            }
            image {
              title
              description
              fluid(maxWidth: 640, quality: 90) {
                ...GatsbyContentfulFluid_withWebp
              }
            }
            tiktokLink
            youtubeLink
            instagramLink
            facebookLink
            linkedinLink
            showInstagramFeed
          }
        }
      }
    `
  )

  const byId = {}
  Object.values(data).forEach(({ nodes }) =>
    nodes.forEach(node => {
      byId[node.id] = node
    })
  )
  return byId
}
